module.exports = __webpack_public_path__ + "static/img/McKercher.ada5fb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/McKercher.jpg
// module id = mKj+
// module chunks = 0